const BOLD_KEYS = ['__bold_', '__b_'];
const ITALIC_KEYS = ['__italic_', '__i_'];

const getColorFromItemKey = itemKey => {
  if (itemKey) {
    const colorMatch = itemKey.match(/__color_([^_]+)/);
    return colorMatch ? colorMatch[1] : null;
  }
};

export function getFontStylingFromItemKey(itemKey: string) {
  const isBold = BOLD_KEYS.some(key => itemKey?.includes(key));
  const isItalic = ITALIC_KEYS.some(key => itemKey?.includes(key));
  const colorName = getColorFromItemKey(itemKey);

  if (itemKey && (colorName || isBold || isItalic)) {
    return {
      colorName,
      isBold,
      isItalic,
    };
  }
}
